export default __webpack_public_path__ + "static/media/Dr. Anil Kumar.69fa3325.jpg";